
import { useEffect, useState } from "react";
import api from "../../../services/api";
import { useParams } from "react-router-dom";
import MessageSuccess from "../../../messages/messageSuccess";
import MessageError from "../../../messages/messageError";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import DateHora from "../../../utils/dateHora";
import RegisterAccess from "../../../utils/registerAccess";
import ButtonLeft from "../../../utils/buttonLeft";
import { IconButton, Typography, Card, Grid, TextField, Button, Dialog } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from "@material-ui/core";
import InputDocUpload from "../../../utils/inputFileUpload/inputDocUpload";


const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 100,
        marginBottom: 20,
        padding: 20,
        background: '#85287e',

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: 'wrap',
        gap: '5rem',
        // placeItems: "center",


        minHeight: '30vh',
        backgroundImage: 'url(/img/backGrounds/BgComprimido2.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        boxShadow: '1rem 1rem 1rem #e7f0ed',
    },
    item: {
        padding: 20,
        borderRadius: 5,
        // minWidth: '20%',
    },
    button: {
        borderRadius: 10
    }

}))

export default function FormCreateReclamacao() {
    const classes = useStyles();
    const [reclamacao, setReclamacao] = useState({ descricao: '' })
    const [message, setMessage] = useState('')
    const [messageError, seterrorMessage] = useState('')
    const [response, setResponse] = useState(false);
    const [open, setOpen] = useState(false)
    const [load, setLoad] = useState(false)
    const [tipo, setTipo] = useState('Reclamação')
    const { action } = useParams()

    const handleOpen = (action) => { setOpen(true); setTipo(action) };
    const handleClose = () => setOpen(false);

    useEffect(() => {
        if (action === 'fazer-reclamacao') {
            handleOpen();
            setMessage('');
            setReclamacao({ descricao: '' });
        }
    }, [action])

    async function HandleChangeFile(file, name) {
        setReclamacao((prevCadastro) => ({ ...prevCadastro, [name]: file }))
    }

    function HandleChange(e) {
        e.target.files ?
            setReclamacao({ ...reclamacao, [e.target.name]: e.target.files[0] })
            :
            setReclamacao({ ...reclamacao, [e.target.name]: e.target.value })

    }

    async function createReclamacao() {
        const formData = new FormData();
        formData.append('anexo1', reclamacao?.anexo1 ?? '');
        formData.append('anexo2', reclamacao?.anexo2 ?? '');
        formData.append('nome', reclamacao?.nome ?? '');
        formData.append('email', reclamacao?.email ?? '');
        formData.append('tel', reclamacao?.tel ?? '');
        formData.append('assunto', reclamacao?.assunto ?? '');
        formData.append('descricao', reclamacao?.descricao ?? '');
        formData.append('tipo', tipo);

        setLoad(true)
        seterrorMessage('')
        setMessage('')

        await api.post('/reclamacao/create', formData)
            .then(res => {
                setLoad(false)
                setMessage(res.data.msg)
                setResponse(res.data.reclamacao)
                // console.log(res)
            }).catch(error => {
                seterrorMessage(error.response.data.message)
                setLoad(false)
                // console.log(error)
            })
    }

    return (
        <div>
            {/* SESSAO DE RECLAMACAO */}
            <div className={classes.root} >
                <Typography variant="subtitle1" style={{ margin: 10, fontSize: 22, fontWeight: 'bold', color: '#fff' }}>
                    Tem alguma reclamação, sugestão ou denúncia a fazer?
                </Typography>
                <Grid container spacing={3} gap={3} justifyContent={'center'}>
                    <Grid justifyItems={'center'} item xs={10} sm={2} className={classes.item}>
                        <Button className={classes.button} fullWidth variant="contained" color="inherit" onClick={() => handleOpen("Reclamação")} >Reclamações</Button>
                    </Grid>
                    <Grid justifyItems={'center'} item xs={10} sm={2} className={classes.item}>
                        <Button className={classes.button} fullWidth variant="contained" color="inherit" onClick={() => handleOpen("Sugestāo")} >Sugestões</Button>
                    </Grid>
                    <Grid justifyItems={'center'} item xs={10} sm={2} className={classes.item}>
                        <Button className={classes.button} fullWidth variant="contained" color="inherit" onClick={() => handleOpen("Denúncia")} >Denúncias</Button>
                    </Grid>
                </Grid>

            </div>

            <Dialog
                scroll='body'
                // onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                // maxWidth={'md'}
                fullWidth
            >
                <IconButton color='error' title="fechar" style={{ position: 'absolute', right: 5, fontWeight: 'bold' }} onClick={() => handleClose()}> <CloseIcon /></IconButton>
                {message && <MessageSuccess message={message} />}
                {messageError && <MessageError message={messageError} />}

                <RegisterAccess page={`fazer ${tipo}`} />

                <Typography align="center" >
                    <img src="/icones/Reclamacoes.svg" width={80} style={{ margin: 10 }} />
                    <br />
                    FAÇA AQUÍ A SUA {tipo.toUpperCase()}
                </Typography>

                {!message &&
                    <Card style={{ padding: 20 }}>

                        <Grid xs={12} md item >
                            <TextField
                                margin="dense"
                                type="text"
                                label="Nome"
                                fullWidth
                                size="small"
                                name="nome"
                                variant="outlined"
                                onChange={HandleChange}
                            />
                        </Grid>

                        <Grid xs={12} md item >
                            <TextField
                                margin="dense"
                                type="email"
                                label="Email"
                                fullWidth
                                size="small"
                                name="email"
                                variant="outlined"
                                onChange={HandleChange}
                            />
                        </Grid>

                        <Grid xs={12} md item >
                            <TextField
                                margin="dense"
                                type="number"
                                label="Contacto"
                                fullWidth
                                size="small"
                                name="tel"
                                variant="outlined"
                                onChange={HandleChange}
                            />
                        </Grid>

                        <Grid xs={12} md item >
                            <TextField
                                margin="dense"
                                type="text"
                                label="Assunto"
                                fullWidth
                                size="small"
                                name="assunto"
                                variant="outlined"
                                onChange={HandleChange}
                            />
                        </Grid>

                        <Grid xs={12} md item >
                            <TextField
                                margin="dense"
                                type="text"
                                label="Descrever"
                                fullWidth
                                size="small"
                                multiline
                                minRows={5}
                                name="descricao"
                                variant="outlined"
                                onChange={HandleChange}
                            />
                        </Grid>
                        <small>Até 1000 caracteres: {reclamacao?.descricao.length}</small>


                        {/* ANEXAR DOCUMENTOS COMPLEMENTARES */}

                        <InputDocUpload
                            imputLigth={true}
                            fullWidth={true}
                            onFileSelect={HandleChangeFile}
                            inputName={'anexo1'}
                            inputDescription={'Anexo complementar (opcional)'}
                            inputTitle={'Adicionar anexo (opcional)'}
                            maxSizeInMB={10}
                        />

                        <ButtonLeft load={load} title={'Enviar'} funcao={createReclamacao} disabled={reclamacao?.descricao.length < 20 || reclamacao?.descricao.length > 999 || load} >
                            <Button color="error" onClick={() => handleClose()}>Cancelar</Button>
                        </ButtonLeft>
                    </Card>
                }

                {message &&
                    <Card style={{ padding: 10, marginTop: 20 }}>
                        <Typography style={{ margin: 20 }} align="center">
                            <CheckCircleOutlineIcon fontSize="large" color="success" />
                            <br />
                            {message}
                        </Typography>

                        <Typography style={{ margin: 20, marginBottom: 30 }} >
                            A sua reclamação encontra-se em <strong>{response?.status}</strong>
                            <br />
                            Número de reclamação: <strong>{response?.numero}</strong>
                            <br />
                            Assunto: <strong>{response?.assunto}</strong>
                            <br />
                            Data: <DateHora date={response?.createdAt} />
                        </Typography>
                    </Card>
                }

            </Dialog>
        </div>
    );
}
